module.exports = __webpack_public_path__ + "static/media/logo-satu-data-idn.4ae2cd75.png";